/* product-guitar-strap.js */

document.addEventListener('DOMContentLoaded', function() {
  // Quantity selector logic
  const qtySelectors = document.querySelectorAll('.pgs-quantity-selector');
  
  qtySelectors.forEach(selector => {
    const minusBtn = selector.querySelector('.pgs-qty-btn.minus');
    const plusBtn = selector.querySelector('.pgs-qty-btn.plus');
    const input = selector.querySelector('.pgs-qty-input');
    
    if (minusBtn && plusBtn && input) {
      minusBtn.addEventListener('click', () => {
        const currentValue = parseInt(input.value);
        if (currentValue > 1) {
          input.value = currentValue - 1;
        }
      });
      
      plusBtn.addEventListener('click', () => {
        const currentValue = parseInt(input.value);
        input.value = currentValue + 1;
      });
    }
  });

  // Smooth scroll for hero button
  const heroBtn = document.querySelector('.pgs-hero-btn');
  if (heroBtn && heroBtn.getAttribute('href').startsWith('#')) {
    heroBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const targetId = heroBtn.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);
      
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  }

  // Thumbnail switching logic
  const thumbnails = document.querySelectorAll('.pgs-thumb');
  const mainImage = document.querySelector('.pgs-main-image img');
  
  if (thumbnails.length > 0 && mainImage) {
    thumbnails.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const thumbImg = thumb.querySelector('img');
        if (thumbImg) {
          mainImage.src = thumbImg.src.replace('width=200', 'width=800');
        }
      });
    });
  }
});

